import { reactive } from "vue";

const theme = reactive({
  agentLogo: "pelligra-logo-white.svg",
  devLogo: "basalt-logo-full.svg",
  apiUrl: "https://api.metaluxe.com.au/",
  bunnyApiUrl: "https://api.bunny.net/",
  accessKey: "ec558f34-7538-4b7e-b822-179253457e6b93932c0d-eae6-47b4-b444-1ac035b8ff7f",
  streamToken: "e58405eb-0b98-4947-96ad-fc6bac7c3a80",
  videoLibraryId: "96152",
  streamCdnUrl: "https://vz-d5df7985-17f.b-cdn.net",
  streamApiKey: "dd3ce6d3-af5b-47d7-afaa75942457-447d-4071",
  storageApiPassword: "20771e79-81ee-4256-a31ecce375b1-0593-45a1",
  cdnUrl: "https://www.85springst.metaluxe.com.au",
  devFolder: "/85springstreet",
  videosIcon: "/img/ui-theme/videos-icon.svg",
  rendersIcon: "/img/ui-theme/renders-icon.svg",
  rangeIcon: "/img/ui-theme/range-icon.svg",
  panoramasIcon: "/img/ui-theme/panoramas-icon.svg",
  floorplansIcon: "/img/ui-theme/floorplans-icon.svg",
  dashboardMp4: "theme/dashboard/4K_dashboard.mp4",
  dashboardImg: "theme/dashboard/dashboard.jpg",
  
  // top level menu
  assetsMenuOrder: [
    'demo',
    'intro',
    'apartment-1',
    'apartment-2',
    'apartment-3',
    'amenities',
    'exterior'
  ],
  
  demoMenuOrder: [
    'videos',
    'virtual-tour',
    'balcony-views',
    'floorplans'
  ],
  
  demoAsset: {
    videos: [],
    videosName: [],
    panoramas: [],
    panoramasName: [],
    panoramasUrl: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    balcony: [],
    balconyName: [],
    balconyUrl: []
  },
});

export default { theme };